export const SOFTLINE_FEATURE_LAGERKORREKTUR_ARTIKEL = 'lagerkorrekturArtikel';
export const SOFTLINE_FEATURE_UMBUCHUNGSARTIKEL = 'umbuchungsartikel';

export const SOFTLINE_PERMISSION_LAGERKORREKTUR_ARTIKEL = 'SOFTAPPS.LAGER.LAGERKORREKTUR_ARTIKEL';
